var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"65px","margin-bottom":"16px","text-align":"center"}},[_vm._v("\n    Solo para miembros de secretaría\n"),_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_vm._v(" "),_c('div',{attrs:{"id":"loader"}},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }